import React from 'react';
import ReactToPrint from "react-to-print";

export default class Page7 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <p className="react-print-none">Above and below is a set of tables into which you should enter up
                                                to 6 of the strengths that you
                                                have identified so far. From this you will be prompted with 6
                                                questions that will get you to think
                                                about these strengths, what you are doing at the moment, and
                                                what you can do in the future, in
                                                order to get the most out of them.</p>

                                            <ReactToPrint
                                                trigger={() => <div className={'d-flex justify-content-end'}>
                                                    <div onClick={this.downloadPdf} className="button-print task">Print</div>
                                                </div>}
                                                content={ () => {
                                                    let html = document.body.getElementsByClassName('ilead-tools-pages-content')[0].cloneNode(true);

                                                    let div1 = document.createElement('div');
                                                    div1.className = 'ilead-tools-pages';
                                                    div1.appendChild(html);

                                                    let div2 = document.createElement('div');
                                                    div2.className = 'ilead-tools-body react-print';
                                                    div2.appendChild(div1);

                                                    return div2.cloneNode(true);
                                                }}
                                            />

                                            <br/>
                                            <div className="mobile-scroll">
                                                <table width="100%" border="0" cellSpacing="0"
                                                       cellPadding="0" className="ilead_v_sport">
                                                    <tbody>
                                                    <tr>
                                                        <th width="20%" align="left"
                                                            className="green_curve table_heading_padding">
                                                            <div>Strength</div>
                                                        </th>

                                                        <th width="20%" align="left" valign="top"
                                                            className="table_heading_padding">
                                                            <div className="table_heading_ol">
                                                                <ol className="" start="4">
                                                                    <li>
                                                                        <div>Other areas I can use it?</div>
                                                                    </li>
                                                                </ol>
                                                            </div>
                                                        </th>
                                                        <th width="20%" align="left" valign="top"
                                                            className="table_heading_padding">
                                                            <ol className="table_heading_ol" start="5">
                                                                <li>
                                                                    <div>What actions can
                                                                        I take to do this?
                                                                    </div>
                                                                </li>
                                                            </ol>
                                                        </th>
                                                        <th width="20%" align="left" valign="top"
                                                            className=" green_curve1 table_heading_padding">
                                                            <ol className="table_heading_ol" start="6">
                                                                <li>
                                                                    <div>Barriers &amp; how I
                                                                        will overcome them
                                                                    </div>
                                                                </li>
                                                            </ol>
                                                        </th>

                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">
                                                            <textarea className="textarealargebox"
                                                                      name="6"
                                                                      value={pageData?.Strength?.[6]}
                                                                      onChange={this.props.handleChangePageData('Strength')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen ">

                                                            <textarea className="textarealargebox"
                                                                      name="6"
                                                                      value={pageData?.OtherAreasICanUseIt?.[6]}
                                                                      onChange={this.props.handleChangePageData('OtherAreasICanUseIt')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="6"
                                                                      value={pageData?.WhatActionsCanITakeToDoThis?.[6]}
                                                                      onChange={this.props.handleChangePageData('WhatActionsCanITakeToDoThis')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="6"
                                                                      value={pageData?.BarriersHow?.[6]}
                                                                      onChange={this.props.handleChangePageData('BarriersHow')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">
                                                            <textarea className="textarealargebox"
                                                                      name="7"
                                                                      value={pageData?.Strength?.[7]}
                                                                      onChange={this.props.handleChangePageData('Strength')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen ">

                                                            <textarea className="textarealargebox"
                                                                      name="7"
                                                                      value={pageData?.OtherAreasICanUseIt?.[7]}
                                                                      onChange={this.props.handleChangePageData('OtherAreasICanUseIt')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="7"
                                                                      value={pageData?.WhatActionsCanITakeToDoThis?.[7]}
                                                                      onChange={this.props.handleChangePageData('WhatActionsCanITakeToDoThis')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="7"
                                                                      value={pageData?.BarriersHow?.[7]}
                                                                      onChange={this.props.handleChangePageData('BarriersHow')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">
                                                            <textarea className="textarealargebox"
                                                                      name="8"
                                                                      value={pageData?.Strength?.[8]}
                                                                      onChange={this.props.handleChangePageData('Strength')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen ">

                                                            <textarea className="textarealargebox"
                                                                      name="8"
                                                                      value={pageData?.OtherAreasICanUseIt?.[8]}
                                                                      onChange={this.props.handleChangePageData('OtherAreasICanUseIt')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="8"
                                                                      value={pageData?.WhatActionsCanITakeToDoThis?.[8]}
                                                                      onChange={this.props.handleChangePageData('WhatActionsCanITakeToDoThis')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="8"
                                                                      value={pageData?.BarriersHow?.[8]}
                                                                      onChange={this.props.handleChangePageData('BarriersHow')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">
                                                            <textarea className="textarealargebox"
                                                                      name="9"
                                                                      value={pageData?.Strength?.[9]}
                                                                      onChange={this.props.handleChangePageData('Strength')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen ">

                                                            <textarea className="textarealargebox"
                                                                      name="9"
                                                                      value={pageData?.OtherAreasICanUseIt?.[9]}
                                                                      onChange={this.props.handleChangePageData('OtherAreasICanUseIt')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="9"
                                                                      value={pageData?.WhatActionsCanITakeToDoThis?.[9]}
                                                                      onChange={this.props.handleChangePageData('WhatActionsCanITakeToDoThis')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="9"
                                                                      value={pageData?.BarriersHow?.[9]}
                                                                      onChange={this.props.handleChangePageData('BarriersHow')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">
                                                            <textarea className="textarealargebox"
                                                                      name="10"
                                                                      value={pageData?.Strength?.[10]}
                                                                      onChange={this.props.handleChangePageData('Strength')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen ">

                                                            <textarea className="textarealargebox"
                                                                      name="10"
                                                                      value={pageData?.OtherAreasICanUseIt?.[10]}
                                                                      onChange={this.props.handleChangePageData('OtherAreasICanUseIt')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="10"
                                                                      value={pageData?.WhatActionsCanITakeToDoThis?.[10]}
                                                                      onChange={this.props.handleChangePageData('WhatActionsCanITakeToDoThis')}/>
                                                        </td>
                                                        <td width="20%" align="left" valign="top"
                                                            className="darkgreen">

                                                            <textarea className="textarealargebox"
                                                                      name="10"
                                                                      value={pageData?.BarriersHow?.[10]}
                                                                      onChange={this.props.handleChangePageData('BarriersHow')}/>
                                                        </td>
                                                    </tr>

                                                    <tr>

                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="react-print-none">
                                                <div className="border_subtitle">Reach your ambition</div>
                                                <p>It is better to reach a slightly less ambitious goal than not
                                                    reach it at all!</p>
                                            </div>
                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page6')}
                                                     className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.savePageData('Page8')}
                                                     className="button-next-previous-done task">Next &gt;&gt;
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}